import "/Users/caldis/Code/react-zmage/packages/core/src/components/Background/Background.module.less?css";
export default {"backgroundLayer":"backgroundLayer__CGbNW"};